const steps = [
    {
        n: "I.",
        title: "Take the quiz",
        ad: "WANTED — your honest answers about values, love languages, weekend habits, and the way you fight. The truer, the better.",
        time: "10 min",
        symbol: "✎",
    },
    {
        n: "II.",
        title: "We hand-pick five",
        ad: "DELIVERED — every Monday morning. Five humans whose compatibility resonates across 12 dimensions of you. No more than five. Ever.",
        time: "Mondays",
        symbol: "✉",
    },
    {
        n: "III.",
        title: "Then it's up to you",
        ad: "CONNECT — chat with intention, get AI-curated date spot ideas, meet up in the real world when you're both ready. We'll cheer you on.",
        time: "Forever",
        symbol: "❦",
    },
];

export default function HowItWorks() {
    return (
        <section
            id="how"
            className="relative py-28 lg:py-36"
            data-testid="how-it-works"
        >
            <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
                {/* Newspaper masthead style */}
                <div className="reveal mb-3 rule-thick" />
                <div className="reveal flex items-center justify-between font-mono text-[10px] uppercase tracking-[0.3em] mb-2">
                    <span>Sect. A — How it works</span>
                    <span>Page 02</span>
                </div>
                <div className="reveal mb-14">
                    <h2 className="font-display text-7xl lg:text-[10rem] leading-[0.85] tracking-tighter">
                        Three steps.
                        <br />
                        <span className="font-italic-serif text-[var(--hot)]">
                            One slow yes.
                        </span>
                    </h2>
                </div>

                <div className="grid md:grid-cols-3 gap-0 border-t-2 border-b-2 border-[var(--ink)]">
                    {steps.map((s, idx) => (
                        <div
                            key={s.n}
                            className={`reveal relative p-8 lg:p-10 ${
                                idx > 0 ? "md:border-l-2 border-[var(--ink)]" : ""
                            } ${idx < steps.length - 1 ? "border-b-2 md:border-b-0 border-[var(--ink)]" : ""}`}
                            style={{ transitionDelay: `${idx * 100}ms` }}
                            data-testid={`step-${s.n.replace(".", "")}`}
                        >
                            <div className="flex items-start justify-between">
                                <div className="font-display text-7xl lg:text-8xl text-[var(--hot)] leading-none">
                                    {s.n}
                                </div>
                                <div className="text-4xl text-[var(--ink-soft)]">
                                    {s.symbol}
                                </div>
                            </div>
                            <h3 className="font-display text-4xl mt-8 leading-none">
                                {s.title}
                            </h3>
                            <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-[var(--hot)] mt-4">
                                — {s.time}
                            </div>
                            <p className="mt-5 text-base leading-relaxed text-[var(--ink-soft)] max-w-sm">
                                {s.ad}
                            </p>
                        </div>
                    ))}
                </div>

                <div className="reveal mt-10 text-center font-hand text-2xl text-[var(--hot)]">
                    — and that's the whole thing. ❦
                </div>
            </div>
        </section>
    );
}
